var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ph-compare-main"},[_c('el-backtop'),(_vm.showHeader)?_c('hpheader',{ref:"headerRef"}):_vm._e(),_c('ph-product-add',{attrs:{"footerHeight":_vm.footerHeight,"headerHeight":_vm.headerHeight}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }